export default class Core {
  constructor(moduleName) {
    this.moduleName = moduleName;
    this.path       = new Path(this);
    this.PRODUCTION_DOMAIN = 'benesse.ne.jp';
    this.COOKIE_DOMAIN = this.path.getRootDomain(this.PRODUCTION_DOMAIN)
    this.IS_PRODUCTION = this.COOKIE_DOMAIN === this.PRODUCTION_DOMAIN;
    this.IS_DEVELOP    = !this.IS_PRODUCTION;
  }
}



class Path {

  get _currentScriptPath() {
    if (document.currentScript) {
      return document.currentScript.src;
    } else {
      var scripts = document.getElementsByTagName('script'),
          script  = scripts[scripts.length - 1];

      if (script.src) return script.src;
    }
  }



  constructor(context) {
    this.context           = context;
    this.currentScriptPath = this._currentScriptPath;
    this.sharedRootPath    = window._bcSharedRootPath || this.currentScriptPath.split('?')[0].replace(/\/((?!\/).)+\/((?!\/).)+\.js/, '');
    this.dir               = this.join(this.sharedRootPath, this.context.moduleName);
    this.script            = this.join(this.moduleDir, this.context.moduleName + '.js');
  }



  join() { return Array.prototype.join.call(arguments, '/').replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/') }



  getRootDomain(baseDomain) {
    const hostname = location.hostname;
    if (hostname.indexOf(baseDomain) !== -1) return baseDomain;
    if (hostname.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/)) return hostname;
    const domain = hostname.replace(/^(((?!\.).)*?\.)/, '');
    return domain;
  }
}



// WEBPACK FOOTER //
// ./src/shared/core/index.js